import React from "react";
import { motion } from "framer-motion";

export function SectionHeader({ eyebrow, title, subtitle, center = false, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
      className={`${center ? "text-center max-w-3xl mx-auto" : "max-w-3xl"} mb-12 md:mb-16 ${className}`}
    >
      {eyebrow && <div className={`eyebrow mb-4 ${center ? "justify-center" : ""}`}><span className="eyebrow-line" />{eyebrow}<span className="eyebrow-line" /></div>}
      <h2 className="font-display text-[clamp(2rem,4vw,3.5rem)] font-extrabold text-brand-text leading-[1.08] tracking-tight text-balance">{title}</h2>
      {subtitle && <p className="mt-5 text-[17px] text-brand-muted leading-relaxed max-w-2xl text-balance">{subtitle}</p>}
    </motion.div>
  );
}

export function PageHero({ title, subtitle, breadcrumbs = [] }) {
  return (
    <section className="relative bg-gradient-to-br from-brand-primary via-[#0068c9] to-brand-primary-hover text-white overflow-hidden">
      <div className="absolute inset-0 opacity-[0.08]" style={{ backgroundImage: "radial-gradient(circle at 20% 20%, white 1.5px, transparent 1.5px)", backgroundSize: "28px 28px" }} />
      <div className="absolute -top-16 -right-16 w-96 h-96 rounded-full bg-brand-secondary/20 blur-3xl" />
      <div className="absolute -bottom-32 left-1/4 w-96 h-96 rounded-full bg-brand-accent/10 blur-3xl" />
      <div className="container-wide py-20 md:py-28 relative">
        {breadcrumbs.length > 0 && (
          <div className="text-[11px] uppercase tracking-[0.28em] text-white/70 mb-5">
            {breadcrumbs.map((b, i) => <span key={i}>{b}{i < breadcrumbs.length - 1 && <span className="mx-3 text-white/40">/</span>}</span>)}
          </div>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
          className="font-display text-[clamp(2.25rem,5vw,4.5rem)] font-extrabold leading-[1.05] tracking-tight max-w-3xl text-balance"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.15, ease: [0.22, 1, 0.36, 1] }}
            className="mt-5 text-white/85 text-lg md:text-xl max-w-2xl leading-relaxed font-light"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 24 }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
}
